<template>
<div class="chapter">
<div class="inner_page">
<section class="chap" epub:type="chapter" id="chap-001"><span epub:type="pagebreak" id="page_8" title="8"><div class="chap_debut"></div><h1 class="chap_surtit" epub:type="title"><span><img alt="" class="imagelarge_intext" id="box_1" src="images/box.jpg"/></span></h1><h1 class="chap_n" epub:type="title"><span><img alt="" class="image_intext" id="c1" src="images/c1.jpg"/></span></h1><h1 class="chap_tit" epub:type="title"><span>ANDREW</span></h1><h1 class="chap_stit" epub:type="subtitle"><span>Bringing Others to Jesus</span></h1><p class="auteur">John 1:35-42</p><div class="dev"><p class="txt_courant_ssalinea"><span class="let">I</span> <b>would like to have </b>Andrew as a brother. If I had known Jesus’ closest followers personally, I might have gone to Nathanael for a Bible study or to Matthew for investment advice, but for a friend, a brother who would love me no matter what, I would have chosen Andrew.</p><p class="txt_courant_justif">Andrew was not one of the major players among the twelve disciples. In fact, he always seems to play a supporting role. In most of his appearances, however, he is bringing someone else to Jesus.</p><p class="txt_courant_justif">I am starting this study of the Twelve with Andrew because Jesus starts with him. According to the New Testament, Andrew was the first of the Twelve to follow Jesus. In the early centuries of the church Andrew was called <i>prōtoklētos </i>(proto-clay-toss), a Greek word that means “first-called”—and the first thing Andrew did after he believed was look for his brother.</p><p class="txt_courant_ssalinea"><b>Group Discussion.</b> What qualities would you look for in someone who is truly a “brother” or a “sister”? If you are comfortable doing it, share with the group who that person is in your life.</p><p class="txt_courant_ssalinea"><b>Personal Reflection.</b> Who are the people you think of as a “brother” or “sister”—people you have a close, trusting relationship with? What can you do this week to strengthen (or to cultivate) that relationship?</p><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><p class="txt_courant_ssalinea">Andrew was on a search. He had a deep spiritual hunger and wanted the Lord to have the primary place in his heart and mind. Andrew was a disciple of John the Baptist and had absorbed this eccentric preacher’s <span epub:type="pagebreak" id="page_9" title="9">message of repentance and preparation. One day Andrew saw John point to a man at the edge of the crowd. “Look,” John said, “the Lamb of God, who takes away the sin of the world!” (<a class="url" href="https://www.biblegateway.com/passage/?search=Jn+1%3A29&amp;version=NIV" target="_blank">Jn 1:29</a>). The next day Andrew and an unnamed disciple (probably John the son of Zebedee) left the Baptist and began to follow Jesus. <i>Read John 1:35-42.</i></span></p><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>1. </b>From what you read in this passage, give a brief description of each person’s role in the story.</p></div><p class="txt_courant_ssalinea retrait_gauche">John the Baptist</p><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<textarea name="response2"></textarea>
<br/>
</p>
</form><p class="txt_courant_ssalinea retrait_gauche">Jesus</p><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><p class="txt_courant_ssalinea retrait_gauche">Andrew</p><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><p class="txt_courant_ssalinea retrait_gauche">the other disciple</p><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><p class="txt_courant_ssalinea retrait_gauche">Simon Peter</p><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>2. </b>How do you think John felt when two of his followers left him and began following Jesus (v. 37)?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>3. </b>Explain what Jesus meant when he asked, “What do you want?” Was it a simple question or more than that?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>4. </b>What prompted you to seek after Jesus—curiosity, the faith of your parents, a Christian friend, the testimony of the Bible? Explain the factors that drew you to faith or interest in Jesus.</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><span epub:type="pagebreak" id="page_10" title="10"><b>5. </b>The first thing Andrew did when he was convinced that Jesus was the promised Messiah was to find his brother, Simon (vv. 41-42). As a child, what did it take to convince you that something your brother or sister (or closest friend) told you was true?</span></p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche">Why do you think Simon might have struggled with Andrew’s announcement?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>6. </b>Why is it sometimes difficult to talk to our family members (or closest friends) about a commitment to Jesus?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>7. </b>What can we do if those closest to us reject Jesus’ offer of forgiveness and salvation?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>8. </b>Later, when Jesus called Andrew away from his fishing career to full-time discipleship, Andrew dropped what he was doing and followed Jesus (<a class="url" href="https://www.biblegateway.com/passage/?search=Mt+4%3A19-20&amp;version=NIV" target="_blank">Mt 4:19-20</a>). What does that response to discipleship tell you about the sincerity of Andrew’s commitment here in John 1?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche">Share a time when you sensed Jesus calling you to a new level of commitment to him. How did you respond to that discipleship call?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><span epub:type="pagebreak" id="page_11" title="11"><b>9. </b>In every later reference to Andrew in the New Testament, he is called “Simon Peter’s brother.” Everyone knew Peter; not as many knew Andrew. What does that tell you about Andrew’s character and attitude?</span></p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche"><b>10. </b>What qualities in Andrew do you admire most and why?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="lettre"><p class="txt_courant_ssalinea retrait_gauche">Which one of these do you want to begin to develop or develop further in your own character?</p></div><form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form><div class="encsansfilet" id="encp11"><div class="dev"><p class="txt_courant_ssalinea"><img alt="Illustration" class="image_intext" id="fig-002a" src="images/LBSLeafCOLOR.jpg"/><i>Ask the Lord to give you a willingness to continue to say yes to him.</i></p></div></div><div class="niv3" id="niv3-001"><h2 class="int_niv3" epub:type="title">NOW OR LATER</h2><p class="txt_courant_ssalinea">Three countries claim Andrew as their patron saint: Russia, Scotland and Greece. Church tradition says that Andrew died at Patrae, Greece. The local governor was so enraged that his wife and brother had become Christians that he condemned Andrew to be crucified. Andrew is said to have asked to be executed on an X-shaped cross, feeling unworthy to die on the same shaped cross as Jesus. The X-shaped cross has been known ever since as Saint Andrew’s cross. Andrew lingered on the cross for almost three days, and during hours of consciousness he urged those looking on to believe in Jesus.</p><p class="txt_courant_justif">Think of one or two family members or friends who have not received Jesus as Savior and Lord. Begin to pray regularly for an open door of opportunity to talk with them. Then, when God opens the door, courageously walk through it.</p></div></div></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap1.vue?062f28b4